
<script>
import moment from 'moment'
import {
  calcDeltaPrice,
  formatThousands
} from '@/utils/helpers'
import AviaticketFlightInfo from './FlightInfo.vue'
import baggageIcon from '@/assets/images/icons/baggage.svg?inline'
import withoutBaggageIcon from '@/assets/images/icons/withoutBaggage.svg?inline'
import unknownBaggageIcon from '@/assets/images/icons/unknownBaggage.svg?inline'

export default {
  name: 'aviatickets-control',
  components: {
    AviaticketFlightInfo,
    baggageIcon,
    withoutBaggageIcon,
    unknownBaggageIcon
  },
  props: {
    aviaticket: {
      type: Object,
      required: true
    },
    aviaticketIndex: {
      type: Number,
      required: true
    },
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    getFlight() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
  },
  methods: {
    showTarrifs() {
      this.$store.commit('cart/updateServiceField', {
        target: `flights.${this.flightIndex}.aviatickets.collection.${this.aviaticketIndex}.showTarrifs`,
        value: true
      })
    },
    isCurrentActive(id) {
      return id === this.getFlight.current.id
    },
    async select(aviaticketId) {
      const currentFlight = this.getFlight.collection
        .find(flight => flight.id === this.getFlight.current.id)
      const currentFlightArrivalDate = this.getArrivalDate(currentFlight)
      const newFlight = this.getFlight.collection.find(flight => flight.id === aviaticketId)
      const newFlightArrivalDate = this.getArrivalDate(newFlight)

      this.$store.commit('cart/updateFlightCurrent', {
        flightIndex: this.flightIndex,
        aviaticketId
      })

      if (this.mainServiceIsTours) {
        if (currentFlightArrivalDate === newFlightArrivalDate) {
          await this.updateTransfers()
        } else {
          await this.updateTransfersAndAccommodations()
        }
      }

      this.$store.dispatch('cart/getActualize')
    },
    async updateTransfersAndAccommodations() {
      await Promise.all(
        this.$store.getters['cart/getHotels'].map((hotel, hotelIndex) => {
          const startDate = moment.unix(hotel.accommodations.current.startDate).format('DD.MM.YYYY')

          return this.$store.dispatch('cart/getTourAccommodations', {
            hotelIndex,
            params: {
              ...this.$store.getters['cart/getTourForm'],
              currency: this.$store.getters['cart/getCartPrice'].currency,
              rooms: hotel.form.rooms,
              startDate,
              endDate: moment(startDate, 'DD.MM.YYYY')
                .add(hotel.accommodations.current.duration, 'days')
                .format('DD.MM.YYYY'),
              priceSort: hotel.form.priceSort,
              filters: hotel.filters
            }
          })
        })
      )

      await this.updateTransfers()
    },
    async updateTransfers() {
      const hotels = this.$store.getters['cart/getIds'].hotels
        .map(hotel => hotel.accommodationId)
      const flights = this.$store.getters['cart/getIds'].flights
        .map(flight => flight.recommendationId)
      const transfers = this.$store.getters['cart/getIds'].transfers
        .map(transfer => transfer.vehicleId)

      await this.$store.dispatch('cart/getTourTransfers', {
        hotels,
        flights,
        transfers,
        currency: this.$store.getters['cart/getCartPrice'].currency,
        tourTemplateId: this.$store.getters['cart/getTourForm'].tourTemplateId
      })
    },
    getArrivalDate(flight) {
      const firstDirection = flight.directions[0]
      const segmentsLength = firstDirection.segments.length
      const lastSegment = firstDirection.segments[segmentsLength - 1]
      const arrivalDate = lastSegment.arrival.time

      return moment.unix(arrivalDate).format('DD.MM.YYYY')
    },
    calcDeltaPrice(price) {
      return this.getFlight.current.price.amount === 0
        ? this.formatThousands(price)
        : calcDeltaPrice(this.getFlight.current.price.amount, price)
    },
    formatThousands: number => formatThousands(number)
  }
}
</script>

<template>
  <div class="cart__aviatickets--control cart__aviatickets-control">
    <div class="cart__aviatickets-control--top">
      <div class="cart__aviatickets-control--services">
        <baggageIcon
          v-if="aviaticket.haveBaggage"
        />
        <unknownBaggageIcon
          v-if="!aviaticket.haveBaggage && aviaticket.hasAnotherTariffs"
        />
        <withoutBaggageIcon
          v-if="!aviaticket.haveBaggage && !aviaticket.hasAnotherTariffs"
        />
      </div>
      <aviaticket-flight-info
        :aviaticket-id="aviaticket.id"
        :flight-index="flightIndex"
        wrapper-class="cart__aviatickets-control--info-btn"
      />
    </div>
    <div class="cart__aviatickets-control--info">
      <p class="cart__aviatickets-control--class">
        {{ aviaticket.class }}
      </p>
      <p class="cart__aviatickets-control--price">
        {{ calcDeltaPrice(aviaticket.price.amount) }}
        {{ aviaticket.price.currency }}
      </p>
    </div>
    <div class="cart__aviatickets-control--links">
      <b-button
        v-if="aviaticket.hasAnotherTariffs"
        class="rex-button2"
        type="is-light"
        :outlined="true"
        expanded
        @click="showTarrifs"
      >
        Изменить тариф
      </b-button>
      <b-button
        v-if="!isCurrentActive(aviaticket.id)"
        class="rex-button2"
        type="is-primary"
        expanded
        @click="select(aviaticket.id)"
      >
        Выбрать
      </b-button>
      <b-button
        v-if="isCurrentActive(aviaticket.id)"
        class="rex-button2"
        type="is-primary"
        :outlined="true"
        expanded
      >
        Выбран
      </b-button>
    </div>
  </div>
</template>
